import m, {MithrilComponent, state} from '@bitstillery/mithril'
import {Button, FieldCheckbox, Icon} from '@bitstillery/common/components/portal'
import {$t} from '@bitstillery/common/app'
import {CartValidation} from '@bitstillery/common/api/fact2server'
import {$m, $s} from '@/app'
import {conditional, required, validation} from '@bitstillery/common/lib/validation'

export class CartConfirmations extends MithrilComponent {
    data = state({
        form: {
            terms_price_up: false,
        },
        loading: false,
        lockedGiftPlaceholder: '',
    })

    $v = {
        terms_price_up: validation(
            this.data.form.$terms_price_up,
            conditional(() => {
                const priceRaisedErrors = $s.cart.errors[CartValidation.PRICE_WAS_RAISED]
                return Object.values(priceRaisedErrors).length > 0
            }, required()),
        ),
    }

    view() {
        const has_errors = $m.cart.has_errors()
        // The price-up acknowledgement is only required when there are actual
        // price-raised errors. Quantity/availability-only errors have no
        // checkbox, so gating the button on it would leave it permanently
        // disabled and block the user from fixing the cart.
        const price_up_count = Object.keys($s.cart.errors[CartValidation.PRICE_WAS_RAISED]).length
        const has_price_up_errors = price_up_count > 0
        return (
            <div className='confirmations c-cart-confirmations'>
                <div className='confirmation active'>
                    {has_errors && (
                        <>
                            {has_price_up_errors && (
                                <div className='acknowledge'>
                                    <FieldCheckbox
                                        disabled={!$s.cart.artkey}
                                        label={
                                            <span>
                                                {m.trust(
                                                    $t('cart.price_up_agree', {
                                                        count: price_up_count,
                                                    }),
                                                )}
                                            </span>
                                        }
                                        help={$t('cart.price_up_agree_help', {
                                            count: price_up_count,
                                        })}
                                        model={this.data.form.$terms_price_up}
                                        validation={this.$v.terms_price_up}
                                    />
                                </div>
                            )}
                            <Button
                                className='btn-confirm-step'
                                disabled={has_price_up_errors && !this.data.form.terms_price_up}
                                loading={this.data.loading}
                                icon={'progress_wrench'}
                                onclick={async () => {
                                    this.data.loading = true
                                    await $m.cart.confirm_all_suggestions()
                                    this.data.loading = false
                                }}
                                text={$t('checkout.status.step_fix')}
                                type='info'
                            />
                            {/* Describes what the action does, so it reads after the button it explains. */}
                            <div className='fix-help'>
                                <Icon name='info' size='s' type='info' />
                                <span>{$t('cart.error_fix_help')}</span>
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    }
}
